import { withMapContext } from "common/Map/MapTypeContext";
import { getNearestPointIndex } from "lib/geoUtils";
// import styles from './TrackSnapPoint.scss'
import _ from "lodash";
import React, { Fragment } from "react";

// convenience function, takes two {x, y} objects and gives distance
const distanceBetween = (p1, p2) => Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));

class _TrackSnapPoint extends React.PureComponent {
  onMapMouseMove = (syntheticMapEvent) => {
    const { troute, mapEngine, onUnSnap } = this.props;
    const mouseLatLng = syntheticMapEvent.latLng;
    // step 1: calculate the nearest trackPoint index to the mouse, with
    // a distance threshold of 0.5 deg
    const snapIndex = getNearestPointIndex(troute, mouseLatLng, 0.5);
    if (!snapIndex) {
      // clear the current highlight point if there was one
      this.pointIsHighlighted() && onUnSnap();
      return;
    }
    const snapTrackPoint = troute.trackPoints[snapIndex];

    // step 2: calculate the *pixel* distance between the mouse coordinates
    // and the coordinates indicated by the snapIndex
    const mousePx = syntheticMapEvent.pixelCoordinates;
    const snapPx = mapEngine.latLngToPixelCoordinate(snapTrackPoint);
    const pixelDistance = distanceBetween(mousePx, snapPx);

    // step 3: if the pixel distance is < 50px, we have ourselves a nice
    // valid snap point. Let the parent know about it!
    if (pixelDistance < 50) {
      this.props.onSnap({ snapPoint: snapTrackPoint, snapIndex });
      return;
    }

    // step 4: if the mouse is moving over the map, but the pixel distance is
    // > 50px OR we can't find a valid snapIndex at all, we should clear any
    // *existing* snapPoints from the parent.
    this.pointIsHighlighted() && onUnSnap();
  };

  pointIsHighlighted = () => {
    const { hoveredFeature } = this.props;
    return _.get(hoveredFeature, "data.highlightPoint");
  };

  render() {
    const { mapType, mapInstance, mapEngine } = this.props;
    return (
      <Fragment>
        {mapType === "google" ? (
          <GoogleMapTracker
            mapInstance={mapInstance}
            mapEngine={mapEngine} // mapEngine is only needed here for re-projection of latLng to pixels
            onMouseMove={this.onMapMouseMove}
          />
        ) : (
          <MapboxMouseTracker mapInstance={mapInstance} onMouseMove={this.onMapMouseMove} />
        )}
      </Fragment>
    );
  }
}

const THROTTLE_FPS = Math.floor(1000 / 24); // throttle mouse events at 24FPS

// this only exists to hook into the mount/unmount lifecycle events and
// translate between google pointer events and synthetic pointer events,
// so that we don't have to manually try to keep track of mapEngine
// changes in TrackSnapPoint itself
class GoogleMapTracker extends React.PureComponent {
  componentDidMount() {
    const { mapInstance } = this.props;
    this._mouseMoveListener = mapInstance.addListener("mousemove", this.onMouseMove);
  }

  componentWillUnmount() {
    this._mouseMoveListener && this._mouseMoveListener.remove();
  }

  onMouseMove = _.throttle(
    (e) => {
      const { mapEngine } = this.props;
      const latLng = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      // the e.pixel value doesn't match any of the coordinate systems returned
      // by the google map projection latLngToPoint method, so we have to
      // do the projection manually here
      const pixelCoordinates = mapEngine.latLngToPixelCoordinate(latLng);
      const syntheticMapEvent = { pixelCoordinates, latLng };
      this.props.onMouseMove(syntheticMapEvent);
    },
    THROTTLE_FPS,
    { leading: true, trailing: false }
  );

  render() {
    return null;
  }
}

class MapboxMouseTracker extends React.PureComponent {
  componentDidMount() {
    const { mapInstance } = this.props;
    mapInstance.on("mousemove", this.onMouseMove);
  }

  componentWillUnmount() {
    const { mapInstance } = this.props;
    mapInstance.off("mousemove", this.onMouseMove);
  }

  onMouseMove = _.throttle(
    (e) => {
      const pixelCoordinates = e.point;
      const latLng = e.lngLat;
      const syntheticMapEvent = { pixelCoordinates, latLng };
      this.props.onMouseMove(syntheticMapEvent);
    },
    THROTTLE_FPS,
    { leading: true, trailing: false }
  );

  render() {
    return null;
  }
}

export const TrackSnapPoint = withMapContext(_TrackSnapPoint);
